
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/projects/create",
      function () {
        return require("private-next-pages/projects/create/index.page.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/projects/create"])
      });
    }
  